import {
    Box,
    Button,
    Grid,
    Modal,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Backdrop
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import * as pdfjsLib from "pdfjs-dist";
import styles from "./Fno_ActivationStyles";
import { httpRequest } from "../../../../../ui-utils/api";
import loadergif from '../../../../../ui-assets/load.gif'
import { backendHosts, apiUrl } from "../../../../../ui-utils/apiConfig";
import * as CryptoJS from "crypto-js";
import axios from "axios";
// Configure PDF worker
pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`;


// Mock style and uploader placeholder
// const aggregatorModalStyle = { backgroundColor: "#fff", width: 600, margin: "auto", marginTop: 100 };
const select = {};
const inputColor = {};
const intSelText = {};
const FileUploader = ({ handleChange, children }) => (
    <div onClick={() => document.getElementById("fileInput").click()}>
        {children}
        <input
            id="fileInput"
            type="file"
            hidden
            accept="application/pdf"
            onChange={(e) => handleChange(e.target.files[0])}
        />
    </div>
);

const Fno_Activation = ({ fno, classes }) => {
    // 🧠 State Management
    const [fileName, setFileName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [enable, setEnable] = useState(false);
    const [baseData, setBaseData] = useState("");
    const [promise, setPromise] = useState(null);
    const [show, setShow] = useState(false);
    const [documentType, setDocumentType] = useState("Bank_Statement");
    const [load, setLoad] = useState(true)
    const [fetch, setFetch] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [mainError, setMainError] = useState('')
    const [pendingRecord, setPendingRecord] = useState(null);
    const [approvedRecord, setApprovedRecord] = useState(null);
    const [rejectedRecords, setRejectedRecords] = useState([]);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [createNew, setCreateNew] = useState(false)
    console.log("fnoo",fno)
    const username = localStorage.getItem('username')

    // 📤 Helper to convert blob to base64
    const convertBlobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // 📄 PDF Upload Handler
    const handlePdf = async (file) => {
        setFileName(file.name);
        setPassword("");
        setError("");
        setShow(false)

        const fsize = (file.size / (1024 * 1024)).toFixed(2);
        if (file.type !== "application/pdf") {
            setError("Invalid file format. Only PDF files are supported.");
            setEnable(false);
            setBaseData("");
            return;
        } else if (fsize > 20) {
            setError("Max 20MB allowed.");
            setEnable(false);
            setBaseData("");
            return;
        }

        
            const processFile = async () => {
                console.log("PDF.js version running:", pdfjsLib.version);
                const fileReader = new FileReader();
                fileReader.onload = async () => {
                    const pdfBytes = new Uint8Array(fileReader.result);
                    let pdfDoc
            while (true) {
                try {
                    const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
                    pdfDoc = await loadingTask.promise;
                    const base64Pdf = await convertBlobToBase64(
                        new Blob([pdfBytes], { type: "application/pdf" })
                    );
                    setBaseData(base64Pdf);
                    setEnable(true);
                    break;
                } catch (error) {
                    console.log("msgg", error)
                    if (error.message === "No password given") {
                        setShow(true);
                        setEnable(false);
                        const enteredPassword = await new Promise((resolve, reject) => {
                            setPromise({ resolve, reject });
                        });

                        try {
                            console.log("paaa", enteredPassword)
                            const loadingTask = pdfjsLib.getDocument({
                                data: pdfBytes,
                                password: enteredPassword,
                            });
                            await loadingTask.promise;
                            const base64Pdf = await convertBlobToBase64(
                                new Blob([pdfBytes], { type: "application/pdf" })
                            );
                            setShow(false);
                            setError("");
                            setEnable(true);
                            setBaseData(base64Pdf);
                            break;
                        } catch (decryptError) {
                            setError("Incorrect password. Please try again.");
                        }
                    } else {
                        setError("Something went wrong. Please try again.");
                        setEnable(false);
                        break;
                    }
                }
            }
        };
        fileReader.readAsArrayBuffer(file);
      };
            await processFile();
     }

    const handlePasswordSubmit = () => {
        if (!password) {
            setError("Please Enter the Password");
        } else {
            promise?.resolve(password);
        }
    };

    // const handleUpload = async () => {
    //     setEnable(false)
    //     console.log("Uploading base64 PDF:", baseData, documentType, password);
    //     const formData = {
    //         client_id:fno?.client_id,
    //         proof_type: "F&O",
    //         fno_type: documentType,
    //         password,
    //         base64: baseData,
    //         dataTxt: "Something",
    //         filename: fileName,
    //     };
    //     const encryptedRequestBody = CryptoJS.AES.encrypt(
    //         JSON.stringify(formData), // Convert to string
    //         "96358214256984120"
    //     ).toString();

    //     const payload = {
    //         data: encryptedRequestBody,
    //     };

    //     try {
    //         const response = await httpRequest({
    //             endPoint: `${backendHosts.ADMIN}${apiUrl.fnoCreate}`,
    //             method: "post",
    //             instance: "instanceOne",
    //             requestBody: payload,
    //         });
    //         if (response.data) {
    //             const secretKey = "96358214256984120"; // Same key used for encryption
    //             const bytes = CryptoJS.AES.decrypt(response.data, secretKey);
    //             const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    //             const parsedData = decryptedData ? JSON.parse(decryptedData) : null;

    //             console.log("Decrypted Data:", parsedData);
    //             if (!parsedData.success) {
    //                 setErrorMsg(parsedData.error);
    //             } else {
    //                 fetchFnoStatus();
    //                 setEnable(true)
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch FNO status:", error);
    //     }
    // };

    const handleUpload = async () => {
    setEnable(false)
    console.log("Uploading base64 PDF:", baseData, documentType, password);


        const payload = {
            data: {
                client_id: fno?.client_id, file_name: `${documentType}_${fno?.mobile}.pdf`, emailid: fno?.email, password:password || "",src:"crm"
            }
        };
        console.log(payload);


        try {
            const createreqdata = await axios.post(
                // AppConfig.api.fno.createRequest,
                `${backendHosts.REG}/fno/create-request`,
                payload
            );

            console.log("createreqdata", createreqdata.data?.data?.msg)

            if (createreqdata.data?.data?.msg === 'FNO request created successfully') {
                setEnable(false)

                console.log("api call to confirm")

                // const timestamp = new Date()
                //   .toISOString()
                //   .replace('T', '_')  // Replace 'T' with '_'
                //   .replace(/:/g, '-') // Replace ':' with '-'
                //   .split('.')[0]; // Remove milliseconds and 'Z'

                // console.log(timestamp); 
                const payload = {
                    data: {
                        "email": fno?.email,
                        "mobile": fno?.mobile,
                        "document_type": `${documentType}`,
                        "base64": baseData,
                        "password": password,
                        "src":"crm"
                    }
                };


                console.log(payload)

                try {
                    const commfileup = await axios.post(
                        `${backendHosts.REG}/api/account-aggregator/upload`,
                        
                        payload
                    );

                    console.log("commfileup", commfileup);
                    if (!commfileup?.data?.data?.data?.success) {
                        setErrorMsg(commfileup?.data?.data?.data?.message);
                    } else {
                        fetchFnoStatus();
                        setEnable(true)
                    }

                    setErrorMsg("");
                    setEnable(false)
                } catch (error) {
                    console.log("An Error Occurred", error);
                    setEnable(false)
                    setErrorMsg("Something went wrong. Please try again.");
                }

            }

        } catch (error) {
            console.log("An Error Occurred", error);
            setEnable(false)
            setErrorMsg("Something went wrong. Please try again.");
        }
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "white",
        boxShadow: 24,
        p: 2,
        borderRadius: "5px",
        maxHeight: "350px",
        // margin:'10px 0px',
    };

    const fetchFnoStatus = async () => {
        setLoad(true)

        const payload = {
            data: {
                client_id:fno?.client_id
            },
        };

        try {
            const response = await httpRequest({
                // endPoint: `${backendHosts.ADMIN}${apiUrl.fnoStatus}`,
                endPoint: `${backendHosts.REG}/fno/all-request-status`,
                method: "post",
                instance: "instanceOne",
                requestBody: payload,
            });

            console.log("FNO Status:", response.data?.data);
            if (response.data?.data) {
              

                const parsedData = response.data?.data

                console.log(" Data:", parsedData);
                let pending = null;
                let approved = null;
                const rejected = [];

                parsedData.forEach((record) => {
                    const item = {
                        status: record.status,
                        requestDate: record.requestdate,
                        approvedBy: record.approvedby,
                        approvedOn: record.approvedon,
                        updatedOn: record.updatedon,
                        remark: record.remark,
                        clientId: record.client_id,
                        email: record.email,
                        phone: record.phone,
                    };

                    if (record.status === "Pending") {
                        console.log("dataat",item)
                        pending = item;
                    } else if (record.status === "Approved") {
                        approved = item;
                    } else if (
                        record.status === "Rejected" ||
                        record.status === "Initialized"
                    ) {
                        rejected.push(item);
                    }
                });

                setPendingRecord(pending);
                setApprovedRecord(approved);
                setRejectedRecords(rejected);
                setLoad(false)
                // setCondition({
                //     status:parsedData[0].status,
                //     remark:parsedData[0].remark
                // })
            }
        } catch (error) {
            setLoad(false)
            setMainError("Something went wrong. Please try again");
            console.error("Failed to fetch FNO status:", error);
        }
    };

    useEffect(() => {
        if (fno?.client_id) {
            fetchFnoStatus();
        }
    }, [fetch]);

    return (
        <>
            {mainError &&
                <Box className={classes.mainBox}><Typography fontWeight="bold" className={classes.text}>{mainError}</Typography></Box>
            }

            {load === true ?
                <Box className={classes.mainBox}><img src={loadergif} height='100px' width='100px' /></Box> : <>
                    {rejectedRecords.length !== 0 && (
                        <Box className={classes.maincontentBox}>
                            <Button
                                className={classes.historyButton}
                                onClick={handleOpen}
                            >
                                History
                            </Button>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                disableAutoFocus
                                disableEnforceFocus
                            >
                                <Box
                                    sx={{
                                        ...style,
                                        "&::-webkit-scrollbar-button": {
                                            display: "none",
                                            height: 0,
                                            width: 0,
                                        },
                                    }}
                                >
                                    <Box className={classes.historyModalHead}>
                                        <Typography
                                            id="modal-modal-title"
                                            variant="h6"
                                            component="h2"
                                            fontWeight="medium"
                                            className={classes.historyModalHeadText}
                                        >
                                            Client F&O Activation History
                                        </Typography>
                                        <IconButton onClick={handleClose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                    <Box
                                        sx={{
                                            maxHeight: "250px",

                                            overflowY: "auto",

                                            "&::-webkit-scrollbar": {
                                                width: "3px",
                                            },
                                            "&::-webkit-scrollbar-track": {
                                                background: "#dddddd",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                background: "#bbbbbb",
                                            },
                                        }}
                                    >
                                        {rejectedRecords.length === 0 ? (
                                            <Typography color="text.secondary" className={classes.text} fontWeight="bold">
                                                No rejected records found.
                                            </Typography>
                                        ) : (
                                            rejectedRecords.map((item, index) => (
                                                <Box key={index} className={classes.historyModalContent} >
                                                    <Typography variant="subtitle1" fontWeight="medium" className={classes.text}>
                                                        Status: {item.status}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" className={classes.text}>
                                                        Requested On: {item.requestDate}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" className={classes.text}>
                                                        Rejected By: {item.approvedBy || "—"}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" className={classes.text}>
                                                        Rejected On: {item.approvedOn || "—"}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" className={classes.text}>
                                                        Remark: {item.remark || "No remark provided"}
                                                    </Typography>
                                                </Box>
                                            ))
                                        )}
                                    </Box>
                                </Box>
                            </Modal>
                        </Box>
                    )}
                    <Grid className={classes.centerBox}>
                        <Box sx={{ width: "40%" }}>
                            {approvedRecord ? (
                                <Box className={classes.appRejPenBox}>
                                    <Typography className={classes.heading}>
                                        F&O Activation
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                        status - {approvedRecord.status}
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                        Requested on - {approvedRecord.updatedOn}
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                        Approved by - {approvedRecord.approvedBy}
                                    </Typography>
                                    <Typography className={classes.appRejPenText} >
                                        Approved on - {approvedRecord.approvedOn}
                                    </Typography>
                                </Box>
                            ) : pendingRecord ? (
                                <Box className={classes.appRejPenBox}>
                                    <Typography className={classes.heading}>
                                        F&O Activation
                                    </Typography>
                                    <Typography className={classes.appRejPenText} >
                                        status - {pendingRecord.status}
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                            Requested on - {pendingRecord.updatedOn}
                                    </Typography>
                                </Box>
                            ) : rejectedRecords.length > 0 && !createNew ? (
                                // Show latest rejected record
                                <Box className={classes.appRejPenBox}>
                                    <Typography className={classes.heading}>
                                        F&O Activation (Rejected)
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                        Status - {rejectedRecords[0].status}
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                                Requested on - {rejectedRecords[0].updatedOn}
                                    </Typography>
                                    <Typography className={classes.appRejPenText}>
                                        Remark - {rejectedRecords[0].remark || "—"}
                                    </Typography>

                                    <Button
                                        className={classes.uploadButton}
                                        sx={{ mt: 2 }}
                                        onClick={() => setCreateNew(true)}
                                    >
                                        Create Another
                                    </Button>
                                </Box>
                            ) : (
                                <Box>
                                    <Box sx={{ textAlign: "center !important" }}>
                                        <Typography className={classes.heading}>
                                            Create FNO Activation Request
                                        </Typography>
                                    </Box>

                                    <FormControl variant="standard" fullWidth sx={{ mt: 3 }}>
                                        <InputLabel
                                            id="demo-select-small-label"
                                            className={classes.inputColor}
                                        // shrink={true}
                                        >
                                            Document Type
                                        </InputLabel>
                                        <Select
                                            id="demo-select-small"
                                            labelId="demo-simple-select-label"
                                            className={classes.select}
                                            value={documentType}
                                            displayEmpty
                                            onChange={(e) => setDocumentType(e.target.value)}
                                        >
                                            <MenuItem value="Bank_Statement" className={classes.text}>
                                                Latest Bank Statement of Last 6 Months
                                            </MenuItem>
                                            <MenuItem value="Salary_Slip" className={classes.text}>
                                                Salary Slip (Last Month)
                                            </MenuItem>
                                            <MenuItem value="ITR" className={classes.text}>
                                                IT Return (Last Year)
                                            </MenuItem>
                                            <MenuItem value="Net_Worth" className={classes.text}>
                                                Net Worth Certificate
                                            </MenuItem>
                                            <MenuItem value="Demat_Statement" className={classes.text}>
                                                Demat Holding Statement
                                            </MenuItem>
                                            <MenuItem value="Form_16" className={classes.text}>
                                                Copy of last Form 16
                                            </MenuItem>
                                        </Select>
                                    </FormControl>

                                    <Box mt={4}>
                                        <FileUploader handleChange={handlePdf}>
                                            <Box className={classes.uploadBox}>
                                                <Typography>
                                                    Drag and Drop here /{" "}
                                                    <span style={{ color: "#42a0f7" }}>Browse File</span>
                                                </Typography>
                                            </Box>
                                        </FileUploader>
                                    </Box>

                                    {error && (
                                        <Typography color="error" mt={2} className={classes.text}>
                                            {error}
                                        </Typography>
                                    )}

                                    {fileName && !error && (
                                        <Typography mt={1} className={classes.text}>
                                            {fileName}
                                        </Typography>
                                    )}

                                    {show && (
                                        <Grid container spacing={2} mt={2} alignItems="center">
                                            <Grid item xs={8}>
                                                <TextField
                                                    className={classes.text}
                                                    fullWidth
                                                    size="small"
                                                    label="Password"
                                                    type="password"
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    sx={{
                                                        "& .MuiInputBase-input::placeholder": {
                                                            fontFamily: "cardiuma-M",
                                                            color: "#999", // optional placeholder color
                                                            fontSize: "14px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            fontFamily: "cardiuma-M",
                                                        },
                                                        "& .MuiInputLabel-root": {
                                                            fontFamily: "cardiuma-M",
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    className={classes.uploadButton}
                                                    fullWidth
                                                    variant="contained"
                                                    onClick={handlePasswordSubmit}
                                                >
                                                    Submit
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {errorMsg.length !== "" && (
                                        <Box className={classes.errorBox}>
                                            <Typography className={classes.text}> {errorMsg} </Typography>
                                        </Box>
                                    )}

                                    <Button
                                        sx={{ mt: 2 }}
                                        fullWidth
                                        variant="contained"
                                        disabled={!enable}
                                        onClick={handleUpload}
                                        className={
                                            !enable ? classes.disableButton : classes.uploadButton
                                        }
                                    >
                                        Upload
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </>}
        </>
    );
};

export default withStyles(styles)(Fno_Activation);
